<span
  class="icon-inline"
  v-tooltip.bottom="tooltipOptions"
>
  <BulletSvg :style="svgStyle" />
</span>
